import { heroStats, tickerItems } from '@/mocks/home';

const ENTRY_CHIPS = [
  { label: '微博', icon: 'ri-weibo-fill' },
  { label: '公众号', icon: 'ri-wechat-fill' },
  { label: '推特', icon: 'ri-twitter-x-fill' },
  { label: '电报', icon: 'ri-telegram-fill' },
];

export default function HeroSection() {
  return (
    <section id="top" className="relative flex min-h-[680px] w-full flex-col justify-center overflow-hidden md:min-h-[840px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20magazine%20backdrop%20with%20deep%20crimson%20and%20warm%20amber%20ink%20swirls%2C%20subtle%20paper%20grain%20texture%2C%20dramatic%20dark%20tones%20and%20rich%20contrast%20for%20white%20text%20legibility%2C%20artistic%20non%20realistic%20composition%2C%20high%20detail%2C%20elegant%20atmospheric%20mood&width=1600&height=900&seq=hlgl-hero-01&orientation=landscape"
          alt="黑料官方社交矩阵封面"
          title="黑料官方 全平台社交矩阵"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/55 to-foreground-950/85"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-[1200px] px-4 pb-16 pt-28 md:px-6 md:pb-24 md:pt-36">
        <div className="animate-soft-fade w-full rounded-lg border border-background-50/20 bg-foreground-950/45 px-4 py-3 backdrop-blur-md md:px-5 md:py-4">
          <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:gap-6">
            <div className="flex shrink-0 items-center gap-2">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-400"></span>
              </span>
              <span className="font-label text-xs tracking-[0.28em] text-background-50">
                实时更新
              </span>
            </div>

            <div className="relative flex-1 overflow-hidden">
              <div className="marquee-track">
                {[...tickerItems, ...tickerItems].map((text, index) => (
                  <span
                    key={`${text}-${index}`}
                    className="mr-10 flex items-center gap-2 text-xs text-background-100 md:text-sm"
                  >
                    <i className="ri-radio-line text-primary-300"></i>
                    {text}
                  </span>
                ))}
              </div>
            </div>

            <div className="flex shrink-0 flex-wrap items-center gap-2">
              {ENTRY_CHIPS.map((chip) => (
                <a
                  key={chip.label}
                  href="#matrix"
                  className="flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 text-xs text-background-50 transition-colors hover:bg-background-50/20"
                >
                  <i className={`${chip.icon} text-sm`}></i>
                  {chip.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 max-w-3xl md:mt-16">
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-accent-400" aria-hidden="true"></span>
            <span className="font-label text-xs tracking-[0.34em] text-accent-300">
              黑料官方 · 社交矩阵总入口
            </span>
          </div>
          <h2 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl md:leading-[1.18]">
            一个入口，
            <br className="hidden sm:block" />
            锁定黑料官方发布的每一条动态
          </h2>
          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
            聚合黑料官方微博、公众号、推特及电报等全平台账号信息，方便你第一时间锁定
            <strong className="font-semibold text-background-50">黑料官方</strong>
            社交矩阵，随时跟进各渠道发布的动态与内容，不再错过任何一条来自黑料官方的消息。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center md:mt-10">
            <a
              href="#matrix"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-background-100"
            >
              <i className="ri-links-line text-base"></i>
              查看全部官方账号
            </a>
            <a
              href="#feed"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-article-line text-base"></i>
              浏览最新动态
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-x-10 gap-y-6 border-t border-background-50/20 pt-8 md:mt-16">
          {heroStats.map((stat) => (
            <div key={stat.label} className="flex items-baseline gap-2">
              <span className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {stat.value}
              </span>
              <span className="text-xs text-background-100 md:text-sm">{stat.unit}</span>
              <span className="ml-1 text-xs tracking-widest text-background-100/70 md:text-sm">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}